module.exports = __webpack_public_path__ + "static/waterteethermain-6fbe034c01d33a2b9caa3ce2ff7ca87b.jpeg";